import { render, staticRenderFns } from "./JiesuanForm.vue?vue&type=template&id=019bbf44&scoped=true&"
import script from "./JiesuanForm.vue?vue&type=script&lang=js&"
export * from "./JiesuanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019bbf44",
  null
  
)

export default component.exports